import React from "react";
import {
  WSElement,
  WSList,
  WSText,
  WSIcon
} from "@wingspanhq/fe-component-library";
import { OAUTH_SCOPES_DISPLAY } from "../types";
import styles from "./ScopesList.module.scss";

interface ScopesListProps {
  scopes: string[];
}

export const ScopesList: React.FC<ScopesListProps> = ({ scopes }) => {
  if (!scopes || scopes.length === 0) {
    return null;
  }

  const getScopeDescription = (scope: string): string => {
    return OAUTH_SCOPES_DISPLAY[scope] || `Access ${scope} data`;
  };

  return (
    <WSElement>
      <WSText.Paragraph mb="S" weight="medium">
        This application will be able to:
      </WSText.Paragraph>
      <WSList.Vertical>
        {scopes.map(scope => (
          <WSElement key={scope} mb="XS" className={styles.scopeItem}>
            <WSIcon name="check-circle" size="M" color="green500" mr="S" />
            <WSText.Paragraph>{getScopeDescription(scope)}</WSText.Paragraph>
          </WSElement>
        ))}
      </WSList.Vertical>
    </WSElement>
  );
};
